export const SET_DRAWER_COLLAPSED = "setDrawerCollapsed";
export const TOGGLE_DRAWER_COLLAPSED = "toggleDrawerCollapsed";
